import React, { FC } from 'react';

import styles from './Chip.module.scss';

export enum ChipColor {
  Primary = 'primary',
  Secondary = 'secondary',
  Danger = 'danger',
}

interface Props {
  title?: string;
  color?: ChipColor;
  className?: string;
}

export const Chip: FC<Props> = (props) => {
  return (
    <div
      data-color={props.color ?? ChipColor.Primary}
      className={`${styles.chip} ${props.className}`}
    >
      {props.title}
    </div>
  );
};
